module.exports = __webpack_public_path__ + "img/PS-Electrodos.d5cd7961.png";